import React, { Component } from 'react'
import '../../../CSS/global.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import ReusableTextBox from '../../../SharedComponents/Textbox/Textbox'
import * as CleanersDashboardHelpGuideConstant from './CleanersDashboardHelpGuideConstant'
import { Redirect } from 'react-router-dom'
import DashboardAdminHelpPageHeader from '../../Shared/DashboardAdminHelpPageHeader/DashboardAdminHelpPageHeader'
import Loading from '../../../Images/loading.gif'
import { Link } from 'react-router-dom'
import  DashboardHome  from '../../../Images/DashboardHome.PNG'
import  MainNavTab  from '../../../Images/MainNavTab.PNG'
import  Filters  from '../../../Images/Filters.PNG'
import  MissedCleans  from '../../../Images/MissedCleans.PNG'
import  AttendedCleans  from '../../../Images/AttendedCleans.PNG'
import { NavLink } from 'react-router-dom'
import './CleanersDashboardHelpGuide.css'
const $ = require('jquery')


class CleanersDashboardHelpGuide extends Component {
    constructor(props) {
        super()
        this.state = {

        }
    }
    componentDidMount() {
        $(document).ready(function() {
        $(".BakToTop").click(function() {
            $("html, body").animate({scrollTop: 0}, 1000);
         });
         $("#DashhboardHomeClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#DashhboardHomeScroll").offset().top -100
            }, 2000);
          });
          $("#MainNavigationClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#MainNavigationScroll").offset().top -100
            }, 2000);
          });
          $("#UsingFiltersClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#UsingFiltersScroll").offset().top -100
            }, 2000);
          });
          $("#AttendedCleanClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#AttendedCleanScroll").offset().top -100
            }, 2000);
          });
        $("#MissedCleanClick").on('click', function (e) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: $("#MissedCleanScroll").offset().top -100
          }, 2000);
        });
    })
    }
    render() {
        return(
            <div>
                 {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
            <DashboardAdminHelpPageHeader/>
            <div className="HelpGuide">
            <div className="HelpGuideTopics">     
            <h3>{CleanersDashboardHelpGuideConstant.DashboardHaeder}</h3>
            <p>{CleanersDashboardHelpGuideConstant.ChooseTopic}</p>
                    <div className="NavLinksHelp">
                    <ul>
                        <li id="DashhboardHomeClick">{CleanersDashboardHelpGuideConstant.DashboardHome}</li>
                        <li id="MainNavigationClick">{CleanersDashboardHelpGuideConstant.MainNavigation}</li>
                        <li id="UsingFiltersClick">{CleanersDashboardHelpGuideConstant.UsingFilters}</li>
                        <li id="AttendedCleanClick">{CleanersDashboardHelpGuideConstant.AttendedClean}</li>
                        <li id="MissedCleanClick">{CleanersDashboardHelpGuideConstant.MissedClean}</li>
                    </ul>
                        </div>
                        </div>
                        <div className="FirstTab" id="DashhboardHomeScroll">
                        <p>{CleanersDashboardHelpGuideConstant.DashboardHome}</p>
                        <img src={DashboardHome} alt="" className="HomeImage"/>
                        <div className="FirstFlex">
                        <h5>{CleanersDashboardHelpGuideConstant.Widget}</h5>
                        <p>{CleanersDashboardHelpGuideConstant.DashboardHomeP1}</p>
                        </div>
                        <div className="FirstFlex">
                        <h5 className="Widget">{CleanersDashboardHelpGuideConstant.Widget}</h5>
                        <p>{CleanersDashboardHelpGuideConstant.DashboardHomeP2}</p>
                        </div>
                        </div>
                <div className="FirstTab" id="MainNavigationScroll">
                        <p>{CleanersDashboardHelpGuideConstant.MainNavigation}</p>
                        <img src={MainNavTab} alt="" className="HomeImage"/>
                        <p>{CleanersDashboardHelpGuideConstant.MainNavHead}</p> 
                        <div className="FirstFlex">
                       <span className="dot">
                           .</span> <p>{CleanersDashboardHelpGuideConstant.MainNavP1}</p>
                        <p>{CleanersDashboardHelpGuideConstant.MainNavP2}</p>
                        </div>
                        <div className="FirstFlex">
                        <span className="dot">
                           .</span>
                        <p>{CleanersDashboardHelpGuideConstant.MainNavP3}</p>
                        <p>{CleanersDashboardHelpGuideConstant.MainNavP4}</p>
                        </div>   
                </div>
                <div className="FirstTab" id="UsingFiltersScroll">
                        <p>{CleanersDashboardHelpGuideConstant.UsingFilters}</p>
                        <img src={Filters} alt="" className="HomeImage"/>
                        <p>{CleanersDashboardHelpGuideConstant.FilterHead}</p> 
                        <p>{CleanersDashboardHelpGuideConstant.FilterP1}</p> 
                        <p>{CleanersDashboardHelpGuideConstant.FilterP2}</p> 
                        <ul>
                            <li>{CleanersDashboardHelpGuideConstant.FilterP3}</li>
                            <li>{CleanersDashboardHelpGuideConstant.FilterP4}</li>
                            </ul>
                        <p>{CleanersDashboardHelpGuideConstant.FilterP5}</p>
                        <p>{CleanersDashboardHelpGuideConstant.FilterP6}</p>  
                        <p>{CleanersDashboardHelpGuideConstant.FilterP7} {CleanersDashboardHelpGuideConstant.FilterP8}</p>
                        
                        <div className="BakToTop" id="BakToTop">
                    <p>{CleanersDashboardHelpGuideConstant.BackToTop}</p>
                    </div>
                </div>
                   
                <div className="FirstTab" id="AttendedCleanScroll">
                        <p>{CleanersDashboardHelpGuideConstant.AttendedClean}</p>
                        <img src={AttendedCleans} alt="" className="HomeImage"/>
                        <h5>{CleanersDashboardHelpGuideConstant.AttendedHead}</h5> 
                        <p>{CleanersDashboardHelpGuideConstant.AttendedP1}</p>
                        <h5>{CleanersDashboardHelpGuideConstant.AttendedP2}</h5> 
                        <p>{CleanersDashboardHelpGuideConstant.AttendedP3}</p>
                        <div className="BakToTop" id="BakToTop">
                    <p>{CleanersDashboardHelpGuideConstant.BackToTop}</p>
                    </div>
                </div>
                
                <div className="FirstTab" id="MissedCleanScroll">
                        <p>{CleanersDashboardHelpGuideConstant.MissedClean}</p>
                        <img src={MissedCleans} alt="" className="HomeImage"/>
                        <h5>{CleanersDashboardHelpGuideConstant.AttendedHead}</h5> 
                        <p>{CleanersDashboardHelpGuideConstant.MissedP1}</p>
                        <h5>{CleanersDashboardHelpGuideConstant.AttendedP2}</h5> 
                        <p>{CleanersDashboardHelpGuideConstant.AttendedP3}</p>
                        <div className="BakToTop" id="BakToTop">
                    <p>{CleanersDashboardHelpGuideConstant.BackToTop}</p>
                    </div>
                </div>
               
                </div>

            </div>
        )
    }

}
export default CleanersDashboardHelpGuide;